"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var WidgetManager_1 = require("../utils/WidgetManager");
/**
 * DynamicThemeComponent registers itself to the WidgetManager on mount
 * and unregisters on willUnmount.
 */
var DynamicThemeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicThemeComponent, _super);
    function DynamicThemeComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicThemeComponent.prototype.componentDidMount = function () {
        WidgetManager_1.WidgetManager.registerWidget(this);
    };
    DynamicThemeComponent.prototype.componentWillUnmount = function () {
        WidgetManager_1.WidgetManager.unregisterWidget(this);
    };
    return DynamicThemeComponent;
}(React.Component));
exports.DynamicThemeComponent = DynamicThemeComponent;
//# sourceMappingURL=DynamicThemeComponent.js.map